module.exports = __webpack_public_path__ + "static/media/telegram.cdf53b76.svg";